/* global ymaps3 */
import { buildMap } from '@/views/map';

import axios from '@/helpers/axios';
import { isMobile } from '@/helpers/mobile_detect';
import onIntersectionObserve from '@/helpers/on_intersection_observe';
import asyncSweetScroll from '@/helpers/sweet_scroll';

let comparisonSliderApp = null;
let leadFormApp = null;
let map = null;

let swiper03 = null;
let swiper07 = null;

pageUnload('franchises_show', () => {
  if (comparisonSliderApp) {
    comparisonSliderApp.unmount();
    comparisonSliderApp = null;
  }
  if (leadFormApp) {
    leadFormApp.unmount();
    leadFormApp = null;
  }
  if (map) {
    map.destroy();
    map = null;
  }
  if (swiper03) {
    swiper03.destroy();
    swiper03 = null;
  }
  if (swiper07) {
    swiper07.destroy();
    swiper07 = null;
  }
});

pageLoad('franchises_show', () => {
  $('article.v4.slide_01 .to-lead').click(() => {
    asyncSweetScroll('article.v4.slide_15');
  });

  $(`
    article.v4.slide_05_minisklad .refresh,
    article.v4.slide_08_minisklad .refresh
  `).on('click', async ({ currentTarget }) => {
    const $button = $(currentTarget);

    $button.prop('disabled', true);
    const value = (await axios.get($button.data('fetch_url'))).data;
    $button.prop('disabled', false);

    const { CountUp } = await import('countup.js');

    const targetId = $button.data('target-node-id');
    const startVal = parseInt($('#' + targetId).text().replace(/ /g, ''));

    const countUp = new CountUp(
      targetId,
      value,
      {
        startVal,
        separator: ' ',
        duration: 0.35
      }
    );
    countUp.start();
  });

  $('article.v4.slide_07_minisklad .placeholder.pending').one('click', ({ currentTarget }) => {
    const $node = $(currentTarget);
    $node
      .removeClass('pending')
      .html(`
        <video
          autoplay
          controls
          height='auto'
          width='100%'
        >
          <source
            src='${$node.data('video_url')}'
            type='video/mp4'
          />
        </video>
      `);
  });

  if (isMobile()) {
    onIntersectionObserve(
      document.querySelector('.slide_03 .swiper-v8'),
      async node => {
        const [{ default: Swiper }, { Navigation, Pagination }] = await Promise.all([
          import('swiper'),
          import('swiper/modules')
        ]);

        swiper03 = new Swiper(node, {
          grabCursor: true,
          wrapperClass: 'columns',
          slideClass: 'column',
          slidesPerView: 1,
          spaceBetween: 16,
          modules: [Pagination],
          pagination: {
            el: '.b-slider-pagination-v4',
            bulletClass: 'bullet',
            bulletActiveClass: 'is-active',
            clickable: true
          }
        });
        swiper03.changeLanguageDirection(document.documentElement.getAttribute('dir'));
      }
    );

    onIntersectionObserve(
      document.querySelector('.slide_07_minisklad .swiper-v8'),
      async node => {
        const [{ default: Swiper }, { Navigation, Pagination }] = await Promise.all([
          import('swiper'),
          import('swiper/modules')
        ]);

        swiper07 = new Swiper(node, {
          grabCursor: true,
          wrapperClass: 'columns',
          slideClass: 'column',
          slidesPerView: 1,
          spaceBetween: 16,
          modules: [Pagination],
          pagination: {
            el: '.b-slider-pagination-v4',
            bulletClass: 'bullet',
            bulletActiveClass: 'is-active',
            clickable: true
          }
        });
        swiper07.changeLanguageDirection(document.documentElement.getAttribute('dir'));
      }
    );
  }

  onIntersectionObserve(
    document.querySelector('.slide_11 #franchise_comparison_slider'),
    async node => {
      const { createApp, h } = await import(/* webpackChunkName: "vue" */ 'vue');
      const { default: Component } = await import('@/vue/franchise/comparison_slider');

      const $node = $(node);

      const comparisonSliderApp = createApp({ // eslint-disable-line vue/one-component-per-file
        setup: () => () => h(Component, {
          leftImageUrl: $node.data(`left_image_${isMobile() ? 'mobile' : 'desktop'}_url`),
          rightImageUrl: $node.data(`right_image_${isMobile() ? 'mobile' : 'desktop'}_url`)
        })
      });
      comparisonSliderApp.mount(node);
    }
  );

  onIntersectionObserve(
    document.querySelector('.slide_15 #franchsie_lead_form'),
    async node => {
      const { createApp, h } = await import(/* webpackChunkName: "vue" */ 'vue');
      const { default: Component } = await import('@/vue/franchise/lead_form');

      const $node = $(node);

      const leadFormApp = createApp({ // eslint-disable-line vue/one-component-per-file
        setup: () => () => h(Component, {
          submitUrl: $node.data('submit_url'),
          leadType: $node.data('leadType'),
          trackEvent: $node.data('trackEvent'),
          trackEventLocation: $node.data('trackEventLocation'),
          privacyUrl: $node.data('privacy_url'),
          faqUrl: $node.data('faq_url'),
          graphqlUrl: $node.data('graphql_url')
        })
      });
      leadFormApp.mount(node);
    }
  );

  onIntersectionObserve(document.querySelector('.slide_16_minisklad #franchise_map'), initMap);
});

async function initMap(mapNode) {
  const { ZOOM_RANGE, loadMapLibrary } = await import(/* webpackChunkName: "ymap" */ '@/views/maps/yandex/map');

  const { Mark } = await loadMapLibrary();
  const { YMapZoomControl, YMapGeolocationControl } = await ymaps3.import('@yandex/ymaps3-controls@0.0.1');

  const innerNode = document.createElement('div');
  innerNode.className = 'ymap-inner';
  mapNode.appendChild(innerNode);

  // https://yandex.ru/dev/jsapi30/doc/ru/ref/
  const ymap = new ymaps3.YMap(innerNode, {
    location: {
      center: $(mapNode).data('map-location-center')[isMobile() ? 'mobile' : 'desktop'],
      zoom: 11
    },
    behaviors: [
      'drag', 'pinchZoom', 'dblClick', 'magnifier', 'oneFingerZoom', 'mouseRotate',
      'mouseTilt', 'pinchRotate', 'panTilt', 'scrollZoom'
    ],
    zoomRange: ZOOM_RANGE,
    showScaleInCopyrights: true
  },
  [
    new ymaps3.YMapDefaultSchemeLayer({}),
    new ymaps3.YMapDefaultFeaturesLayer({})
  ]
  );

  ymap.addChild(
    new ymaps3.YMapMarker(
      {
        coordinates: $(mapNode).data('map-marker-coordinates')
      },
      $(`
        <img
          class="marker"
          src="/assets/static/pages/franchises/slide_16_minisklad/marker.svg"
          style="transform: translateX(-50%) translateY(-100%); margin-top: 2px;"
        />
      `)[0]
    )
  );
}
